<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.prodsize_heading" [ttModel]="edit.prodsize_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-tabs [(ttSelectedId)]="selectedBgColli">
            <tt-tab ttId="COLLIINPUT" ttLabel="bg_colli_colliinput"></tt-tab>
            <tt-tab ttId="COLLIEXAMPLE" ttLabel="bg_colli_colliexample"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-card class="col-xs-12 col-md-4 p-5">
        <div [hidden]="selectedBgColli !== 'COLLIINPUT'">
            <tt-input-number ttLabel="volum" [(ttModel)]="edit.volum" ttTextAlign="right" ttFormatNumber ttDecimals="6"></tt-input-number>
            <tt-input-number ttLabel="weight" [(ttModel)]="edit.weight" ttTextAlign="right" ttFormatNumber ttDecimals="4"></tt-input-number>
            <tt-input-number ttLabel="weight_net" [(ttModel)]="edit.weight_net" ttTextAlign="right" ttFormatNumber ttDecimals="4"></tt-input-number>
            <tt-input-number ttLabel="colli_pr_unit" [(ttModel)]="edit.colli_pr_unit" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
            <tt-input-number ttLabel="purch_number_default" [(ttModel)]="edit.purch_number_default" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
            <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
            <label *ngIf="edit.collicheck_info !== ''" class="checklist-h2e col-xs-12">{{edit.collicheck_info}}</label>
            <tt-button-goto [ttText]="'prodsizeedit_add_prodsizecolli'" (ttClick)="goToFunc('prodsizecolli')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
        </div>

        <div [hidden]="selectedBgColli !== 'COLLIEXAMPLE'">
            <tt-input-number ttLabel="colliexampleqty" [(ttModel)]="edit.colliexampleqty" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
            <tt-button ttText="colliexampleqty_make_example" (ttClick)="createColliExample()" [ttSpin]="creating" ttIcon="fas fa-sync"></tt-button>
        </div>
    </tt-card>

    <div class="col-xs-12 col-md-4 p-5">
        <tt-list [hidden]="selectedBgColli !== 'COLLIINPUT'" [ttData]="itemsListCollis"></tt-list>
        <tt-list [hidden]="selectedBgColli !== 'COLLIEXAMPLE'" [ttData]="itemsListColliExamples"></tt-list>
    </div>

    <tt-toast class="col-xs-12 col-md-4 p-5" [ttTitle]="'h_list_nobbs'" ttTranslateTitle="true" ttType="primary"></tt-toast>
    <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListNobbs"></tt-list>

    <tt-card class="col-xs-12 col-md-4 p-5" *ngIf="edit.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
